import { IApplicationState } from '../../types/redux';

export const getHeading = (state: IApplicationState) => {
  const { seo, builder } = state.offersData;

  const ifNoBuilder = seo && seo.h1 ? seo.h1 : 'Квартиры в новостройках (ЖК) в Москве';

  return builder ? `Новостройки от застройщика ${builder.name}` : ifNoBuilder;
};
